import React from 'react';
import LoadingSpinner from './LoadingSpinner';

interface PageLoaderProps {
  message?: string;
  subMessage?: string;
  showLogo?: boolean;
}

const PageLoader: React.FC<PageLoaderProps> = ({
  message = 'Loading...',
  subMessage,
  showLogo = true
}) => {
  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow">
            <div className="card-body p-5 text-center">
              {showLogo && (
                <div className="mb-4">
                  <h2 className="text-primary mb-0">EazyHire</h2>
                  <small className="text-muted">Job Search Made Easy</small>
                </div>
              )}
              
              <LoadingSpinner size="lg" variant="primary" />
              
              <div className="mt-4">
                <h5 className="mb-2">{message}</h5>
                {subMessage && (
                  <p className="text-muted small mb-0">{subMessage}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;